import { useApiQuery } from '../../scripts/api/api_v2';
import { GETEventResponseBase, GETSalesResponse } from '../../types/TixAPITypes';
import { useEffect, useState } from 'react';
import { Page } from '../../components/root/Page';
import { SalesPanel } from './SalesPanel';
import { useEditSaleAPI } from '../../scripts/hooks/useEditSaleAPI';
import { ModalEditSale, OnClickEditSaleModal } from '../../components/modals/ModalEditSale';
import { TixBought, TixEvent, TixOrder, TixSale } from '../../types/TixTypes';
import { useEditOrderAPI } from '../../scripts/hooks/useEditOrderAPI';
import { ModalEditOrder, OnClickEditOrderModal } from '../../components/modals/ModalEditOrder';
import { ModalAddSale } from '../../components/modals/ModalAddSale';
import { ModalImportPayments } from '../orders/ModalImportPayments';
import { ModalImportPaymentsNative } from '../orders/ModalImportPaymentsNative';
import { ModalImport } from '../orders/ModalImport';
import { SalesQuaterSelection } from './SalesQuaterSelection';
import { ModalImportRevoPayments } from '../orders/ModalImportRevoPayments';

export function SalesPage() {
	const [importModal, setImportModal] = useState<boolean>(false);
	const [importPaymentsModal, setImportPaymentsModal] = useState<boolean>(false);
	const [importPaymentsNativeModal, setImportPaymentsNativeModal] = useState<boolean>(false);
	const [importPaymentsRevoModal, setImportPaymentsRevoModal] = useState<boolean>(false);

	const [editSaleModal, setEditSaleModal] = useState<Parameters<OnClickEditSaleModal>[0] | undefined>(undefined);
	const [editOrderModal, setEditOrderModal] = useState<Parameters<OnClickEditOrderModal>[0] | undefined>(undefined);
	const [addingSaleModal, setAddingSaleModal] = useState<TixEvent['id'] | undefined>(undefined);

	const [quaterId, selectQuaterId] = useState<string>('uncategorized');

	// TODO: Add loading animation
	const { data, fetchData } = useApiQuery(
		'tix.get-sales',
		{ queryParams: { quaterId: quaterId } },
		{ enabled: true },
	);

	const [cachedData, setCachedData] = useState<GETSalesResponse | undefined>(undefined);

	const { editSaleAPI, updateSale: upsertSaleState } = useEditSaleAPI({ updateState: setCachedData });
	const editOrderAPI = useEditOrderAPI({ updateState: setCachedData });

	// TODO: Add this to useAPIQuery
	useEffect(() => {
		fetchData();
	}, [fetchData]);

	useEffect(() => {
		setCachedData(data);
	}, [data]);

	const onSaleDeleted = (eventId: TixEvent['id'], deletedSaleId: TixSale['id']) => {
		setCachedData((state) => {
			if (!state) return state;
			return {
				...state,
				events: state.events.map((event) => {
					if (event.id !== eventId) return event;
					return { ...event, sales: event.sales.filter((sale) => sale.id !== deletedSaleId) };
				}),
			};
		});
	};

	const onOrderDeleted = (eventId: TixEvent['id'], orderId: TixOrder['id'], seatIds: TixBought['id'][]) => {
		setCachedData((state) => {
			if (!state) return state;
			state.events = state.events.map((event) => {
				if (event.id !== eventId) return event;
				delete event.orders[orderId];
				event.seats = Object.fromEntries(
					Object.entries(event.seats).filter((seat) => seat[1].orderId !== orderId),
				);
				event.sales = event.sales.map((sale) => {
					sale.tixId = sale.tixId.filter((tixId) => !seatIds.includes(tixId));
					return sale;
				});
				return event;
			});
			return state;
		});
	};

	const onSaleAdded = (sale: TixSale, event: GETEventResponseBase) => {
		upsertSaleState({ saleEvent: event, updatedSale: sale });
	};

	const pageActions = [
		{ text: 'Import Revo', action: () => setImportPaymentsRevoModal(true) },
		{ text: 'Import Payments', action: () => setImportPaymentsModal(true) },
		{ text: 'Import Native Payments', action: () => setImportPaymentsNativeModal(true) },
		{ text: 'Import Orders', action: () => setImportModal(true) },
	];

	return (
		<>
			{importModal && <ModalImport closeModal={() => setImportModal(false)} />}
			{importPaymentsModal && <ModalImportPayments closeModal={() => setImportPaymentsModal(false)} />}
			{importPaymentsNativeModal && (
				<ModalImportPaymentsNative closeModal={() => setImportPaymentsNativeModal(false)} />
			)}
			{importPaymentsRevoModal && (
				<ModalImportRevoPayments closeModal={() => setImportPaymentsRevoModal(false)} />
			)}
			{editOrderModal && (
				<ModalEditOrder
					closeModal={() => setEditOrderModal(undefined)}
					editOrderAPI={editOrderAPI}
					onOrderDeleted={onOrderDeleted}
					orderId={editOrderModal.orderId}
					event={editOrderModal.event}
				/>
			)}
			{editSaleModal && (
				<ModalEditSale
					closeModal={() => setEditSaleModal(undefined)}
					saleId={editSaleModal.saleId}
					event={editSaleModal.event}
					onSaleDeleted={onSaleDeleted}
					editSaleAPI={editSaleAPI}
				/>
			)}
			{data && addingSaleModal && (
				<ModalAddSale
					event={data.events.find((event) => event.id === addingSaleModal)!}
					seatIds={[]}
					closeModal={() => setAddingSaleModal(undefined)}
					onSaleAdded={(v) => {
						onSaleAdded(v, data.events.find((event) => event.id === addingSaleModal)!);
					}}
				/>
			)}
			<Page actions={pageActions}>
				<SalesQuaterSelection quaterId={quaterId} selectQuaterId={selectQuaterId} />
				{cachedData && (
					<SalesPanel
						quater={cachedData}
						editSaleAPI={editSaleAPI}
						onClickEditSale={setEditSaleModal}
						onClickEditOrder={setEditOrderModal}
						onClickAddFine={setAddingSaleModal}
					/>
				)}
			</Page>
		</>
	);
}
